import React from "react";
import { DisabledPrompt, BrandingStyle } from "bcms-react";
import { SVGAsset } from "res";
import ImportFileAdditionalValuesTable from "./components/ImportFileAdditionalValuesTable";
import ImportFileAdditionalValuesMobileTable from "./components/ImportFileAdditionalValuesMobileTable";

import "./styles.css";
import "./mobile.css";
/**
 * @function ImportFileAdditionalValuesWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Additional Values widget for the ImportFileNewTemplatePage.
 */
export default function ImportFileAdditionalValuesWidget(props) {
    return (
        <div className="import-file-additional-values-widget">
            <h2>Apply Additional Values</h2>
            <DisabledPrompt>
            <BrandingStyle 
                style={{ "color": "links_abi22", "fill": "links_abi22", }} 
                className="add-container flex-container align-center set-width clickable" 
                element={        
                    <div>
                        <SVGAsset data-point={ `Apply_Additional_Values_Table_Add_Icon` } id="PlusIcon" className="inline-text-icon left-icon add-icon" />
                        <p data-point={ `Apply_Additional_Values_Table_Add_Label` }>Add</p>
                    </div>
            } />
            </DisabledPrompt>
            <div className="show-on-desktop">
                <ImportFileAdditionalValuesTable />
            </div>

            <div className="show-on-mobile">
                <ImportFileAdditionalValuesMobileTable />
            </div>

        </div>
    )
}
